<template>
  <QImage2 :relativePath="relativePath" :size="size" :fallbackIcon="'mdi-home-group'">
  </QImage2>
</template>

<script>
import QImage2 from "@/components/Cards/QImage2.vue";

export default {
  name: "CustomerGroupImage",
  props: {
    size: Number,
    relativePath: String,
  },
  components: {
    QImage2,
  },
  mixins: [],

  data() {
    return {
    };
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>